<template>
  <div class="max-w-7xl mx-auto">
    <h2 class="px-4 text-xl font-medium mt-8">Saved Jobs</h2>
    <div v-if="jobs.length === 0" class="py-12 text-center">
      <svg
        class="mx-auto h-12 w-12 text-gray-400"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        aria-hidden="true"
      >
        <path
          vector-effect="non-scaling-stroke"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
        />
      </svg>
      <h3 class="mt-2 text-sm font-medium text-gray-900">No saved jobs</h3>
      <p class="mt-1 text-sm text-gray-500">
        Get started by browsing and pressing the ♡ button to save that job.
      </p>
      <div class="mt-6">
        <Link
          :href="route('jobs')"
          class="px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        >
          Browse Jobs
        </Link>
      </div>
    </div>
    <div v-else class="my-8 bg-white rounded shadow divide-y">
      <JobCard v-for="job in jobs" :key="`saved-job-${job.id}`" :job="job" />
    </div>
  </div>
</template>

<script>
import { computed } from "vue";

import JobCard from "@/components/Jobs/JobCard";
import { Link } from "@inertiajs/inertia-vue3";

export default {
  props: {
    savedJobs: Object,
  },

  setup(props) {
    const jobs = computed(() => {
      return props.savedJobs.data;
    });

    return {
      jobs,
      route: window.route,
    };
  },

  components: {
    Link,
    JobCard,
  },
};
</script>
